module.exports = __webpack_public_path__ + "img/ico-map.c71ac1a6.svg";